import type { SVGProps } from "react";
import { memo } from "react";
const Omics = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80" {...props}>
    <defs>
      <linearGradient id="prefix__a" x1="0%" x2="100%" y1="100%" y2="0%">
        <stop offset="0%" stopColor="#055F4E" />
        <stop offset="100%" stopColor="#56C0A7" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <path fill="url(#prefix__a)" d="M0 0h80v80H0z" />
      <path
        fill="#FFF"
        d="M28.107 24.142q-1.197.75-2.362 1.476c-3.62 2.254-7.042 4.385-9.588 6.438-3.179 2.562-4.545 5.899-4.063 9.919.368 3.057 2.82 5.978 7.494 8.929l1.07-1.692c-2.26-1.426-3.925-2.833-5.029-4.212h12.372v-2H14.43c-.168-.424-.298-.847-.348-1.264-.402-3.336.688-5.993 3.332-8.124 2.451-1.976 5.821-4.075 9.39-6.297.778-.485 1.57-.978 2.368-1.48C31.907 24.117 37 20.917 37 15v-3h-2v3a8 8 0 0 1-.07 1H14.002v-4h-2v3.986c-.064 4.395 3.781 7.052 6.87 9.187l.314.217 1.14-1.644-.318-.218c-2.229-1.542-4.686-3.247-5.616-5.528h20.001c-1.155 2.708-3.784 4.569-6.286 6.142M43.001 53h25v-2h-25zm0-24h25v-2h-25zm0 16h13v-2h-13zM14.606 62h19.947c-.93-2.28-3.387-3.985-5.617-5.527l-.316-.219 1.138-1.643.315.217c3.09 2.135 6.933 4.792 6.87 9.187V68h-2v-4H14.07a8 8 0 0 0-.069 1v3h-2v-3c0-5.915 5.091-9.115 7.827-10.835q1.2-.753 2.37-1.479c3.567-2.222 6.937-4.321 9.388-6.297 2.644-2.131 3.734-4.789 3.333-8.124-.05-.418-.18-.84-.348-1.265h-11.57v-2h10.37c-1.105-1.378-2.77-2.785-5.029-4.212l1.07-1.691c3.111 1.965 5.216 3.917 6.398 5.903h27.191v2H36.693c.094.341.17.682.212 1.026.482 4.02-.884 7.357-4.063 9.919-2.546 2.053-5.966 4.183-9.588 6.438q-1.165.725-2.362 1.476c-2.502 1.573-5.13 3.434-6.286 6.141"
      />
    </g>
  </svg>
);
const Memo = memo(Omics);
export default Memo;
